import logger from '@/modules/Logger';
import router from '../router';
import store from '@/store/index';
import { store as commonStore } from '@/utils/common';

const verifyPageURL = async (to, from, next) => {
  const pageUrl = to.params.pageUrl;

  try {
    store.dispatch('triallesson/getPageUrl', pageUrl);
    const user = JSON.parse(commonStore.getLessonGeneratorCredentials(pageUrl));
    if (user !== null) {
      await store.dispatch('triallesson/getTrialLessonLists', user);
      store.dispatch('triallesson/setTrialLessonLoginSuccess', true);
    }

    next();
  } catch (error) {
    logger.error('Error verifying the page url' + error,{ 
      event_type: 30,
      operation: 'verify-page-url',
      page_url: pageUrl
     });
    next({ path: 'error' });
  }
};

const verifyTrialLesson = async (to, from, next) => {
  const lessonId = to.params.lessonId;
  const pCompanyId = to.params.pCompanyId;
  const hashCode = to.params.hashCode;
  const user = to.params.user;

  try {
    await store.dispatch('getTrialLessonInfo', { lessonId, pCompanyId, hashCode, user });
    next();
  } catch (error) {
    logger.error('Error getting trial lesson token: ' + error,{ 
      event_type: 31,
      operation: 'verify-trial-lesson',
      lesson_id: lessonId
     });
    router.push({ name: 'TrialLessonGenerator' });
  }
};

export { verifyPageURL, verifyTrialLesson };
